if (!customElements.get('protect-spray-funnel')) {
  let detachedHeaderCart;

  customElements.define('protect-spray-funnel', class extends HTMLElement {
    connectedCallback() {
      document.body.classList.add('cp-funnel');
      this.currency = window.Shopify?.currency?.active || this.dataset.currency;
      this.packInputs = [...this.querySelectorAll('[data-pack]')];
      this.crossSells = [...this.querySelectorAll('[data-cross-sell]')];
      this.packCta = this.querySelector('[data-pack-cta]');
      this.footerAction = this.querySelector('[data-footer-action]');
      this.checkoutButton = this.querySelector('[data-checkout]');
      this.cartSummary = this.querySelector('[data-cart-summary]');
      this.miniCart = this.querySelector('[data-mini-cart]');
      this.miniCartLines = this.querySelector('[data-mini-cart-lines]');
      this.miniCartClose = this.querySelector('[data-mini-cart-close]');
      this.inlineCart = this.querySelector('[data-inline-cart]');
      this.inlineCartLines = this.querySelector('[data-inline-cart-lines]');
      this.sticky = this.querySelector('[data-sticky]');
      this.desktopBreakpoint = window.matchMedia('(min-width: 1024px)');
      this.desktopCart = this.querySelector('[data-desktop-cart]');
      this.desktopCartItems = this.querySelector('[data-desktop-cart-items]');
      this.barrierVideos = [...this.querySelectorAll('[data-barrier-video]')];
      this.videoBreakpoint = window.matchMedia('(min-width: 768px)');
      this.syncCartSummaryInteractivity = () => {
        if (!this.cartSummary) return;
        if (this.videoBreakpoint.matches) {
          this.cartSummary.tabIndex = -1;
          this.cartSummary.setAttribute('aria-hidden', 'true');
          this.closeMiniCart();
        } else {
          this.cartSummary.removeAttribute('tabindex');
          this.cartSummary.removeAttribute('aria-hidden');
        }
      };
      this.syncBarrierVideos = () => {
        this.barrierVideos.forEach((video) => {
          const shouldPlay = (video.dataset.videoBreakpoint === 'desktop') === this.videoBreakpoint.matches;
          if (shouldPlay) video.play().catch(() => {});
          else video.pause();
        });
      };
      this.videoBreakpoint.addEventListener?.('change', this.syncBarrierVideos);
      this.videoBreakpoint.addEventListener?.('change', this.syncCartSummaryInteractivity);
      this.syncBarrierVideos();
      this.syncCartSummaryInteractivity();
      this.syncStickyClearance = () => {
        if (!this.sticky || !window.matchMedia('(min-width: 1024px)').matches) {
          document.body.style.removeProperty('--cp-psf-sticky-clearance');
          return;
        }
        const clearance = Math.ceil(this.sticky.getBoundingClientRect().height) + 16;
        document.body.style.setProperty('--cp-psf-sticky-clearance', `${clearance}px`);
      };
      if ('ResizeObserver' in window && this.sticky) {
        this.stickyResizeObserver = new ResizeObserver(() => this.syncStickyClearance());
        this.stickyResizeObserver.observe(this.sticky);
      }
      window.addEventListener('resize', this.syncStickyClearance, { passive: true });
      this.handlePackChange = (event) => this.selectPack(event.currentTarget);
      this.packInputs.forEach((input) => input.addEventListener('change', this.handlePackChange));
      this.crossSells.forEach((button) => {
        button.querySelectorAll('[data-scent-option]').forEach((option) => option.addEventListener('change', async () => {
          const previousVariantId = button.dataset.variantId;
          button.dataset.variantId = option.value;
          button.dataset.price = option.dataset.price;
          button.dataset.variantTitle = option.dataset.variantTitle;
          if (option.dataset.lineImage) button.dataset.lineImage = option.dataset.lineImage;
          const price = button.querySelector('[data-cross-sell-price]');
          if (price) price.textContent = this.money(Number(option.dataset.price));
          const previousLine = this.realCart?.items?.find((item) => String(item.variant_id) === String(previousVariantId));
          if (previousLine) {
            await this.changeDesktopLine(previousLine.key, 0);
            await this.addDesktopVariant(option.value, 1, true);
          }
        }));
        const toggle = button.querySelector('[data-cross-sell-toggle]') || button;
        toggle.addEventListener('click', async () => {
          await this.toggleDesktopProduct(button);
        });
      });
      this.checkoutButton?.addEventListener('click', () => this.checkout());
      this.cartSummary?.addEventListener('click', () => {
        if (!this.videoBreakpoint.matches) this.toggleMiniCart();
      });
      this.miniCartClose?.addEventListener('click', () => {
        this.closeMiniCart();
        this.cartSummary?.focus();
      });
      this.miniCart?.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-remove-line]');
        if (removeButton) this.decrementLine(removeButton.dataset.removeLine, removeButton.dataset.lineType);
      });
      this.packCta?.addEventListener('click', async () => {
        const pack = this.packInputs.find((input) => input.checked && !input.disabled && input.value);
        if (!pack) return;
        await this.addDesktopVariant(pack.value, 1, true);
        const label = this.packCta.querySelector('span');
        window.clearTimeout(this.packCtaResetTimer);
        label.textContent = this.dataset.itemsAddedLabel || 'ITEMS ADDED';
        this.packCta.classList.remove('is-added');
        void this.packCta.offsetWidth;
        this.packCta.classList.add('is-added');
        this.packCtaResetTimer = window.setTimeout(() => {
          label.textContent = this.packCta.dataset.defaultLabel;
          this.packCta.classList.remove('is-added');
        }, 1600);
        this.querySelector('[data-sticky-shipping]')?.focus?.();
      });
      this.querySelector('[data-desktop-cart-toggle]')?.addEventListener('click', () => this.setDesktopCartExpanded(this.desktopCart?.dataset.expanded !== 'true'));
      this.querySelector('[data-desktop-checkout]')?.addEventListener('click', () => window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`));
      this.querySelectorAll('[data-cart-scroll]').forEach((button) => button.addEventListener('click', () => {
        const direction = button.dataset.cartScroll === 'previous' ? -1 : 1;
        this.desktopCartItems?.scrollBy({ left: direction * 584, behavior: 'smooth' });
      }));
      this.desktopCartItems?.addEventListener('scroll', () => this.syncDesktopCartArrows(), { passive: true });
      this.desktopCartItems?.addEventListener('click', (event) => this.handleDesktopCartAction(event));
      this.footerAction?.addEventListener('click', () => {
        if ((this.realCart?.item_count || 0) > 0) {
          window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
          return;
        }
        this.querySelector('.cp-psf__packs')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.packInputs.find((input) => !input.disabled)?.focus();
      });
      const defaultPack = this.packInputs.find((input) => input.dataset.defaultPack === 'true' && !input.disabled && input.value);
      this.selectPack(defaultPack || this.packInputs.find((input) => input.checked && !input.disabled && input.value));
      this.refreshDesktopCart();

      // Non-essential page chrome must never prevent the staged funnel from initializing.
      try {
        this.initializeDrawerDismissal();
      } catch (error) {
        console.error('Protect Spray Funnel drawer setup failed', error);
      }
      try {
        this.initializeHeaderCartSuppression();
      } catch (error) {
        console.error('Protect Spray Funnel header setup failed', error);
      }
    }

    disconnectedCallback() {
      this.videoBreakpoint?.removeEventListener?.('change', this.syncBarrierVideos);
      this.videoBreakpoint?.removeEventListener?.('change', this.syncCartSummaryInteractivity);
      this.stickyResizeObserver?.disconnect();
      window.removeEventListener('resize', this.syncStickyClearance);
      this.barrierVideos?.forEach((video) => video.pause());
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleEscape);
      this.drawerDismissalInitialized = false;
      if (!document.querySelector('protect-spray-funnel')) {
        document.body.classList.remove('cp-funnel');
        document.body.style.removeProperty('--cp-psf-sticky-clearance');
        if (detachedHeaderCart?.parent?.isConnected) {
          detachedHeaderCart.parent.insertBefore(detachedHeaderCart.node, detachedHeaderCart.nextSibling?.isConnected ? detachedHeaderCart.nextSibling : null);
        }
        detachedHeaderCart = undefined;
      }
    }

    initializeDrawerDismissal() {
      if (this.drawerDismissalInitialized) return;
      this.drawerDismissalInitialized = true;
      this.handleDocumentClick = (event) => {
        const clickPath = event.composedPath?.() || [];
        const sticky = this.querySelector('[data-sticky]');
        const clickedSticky = clickPath.includes(sticky) || sticky?.contains(event.target);
        if (!this.miniCart?.hidden && !clickedSticky) this.closeMiniCart();
      };
      this.handleEscape = (event) => {
        if (event.key === 'Escape' && !this.miniCart?.hidden) {
          this.closeMiniCart();
          this.cartSummary?.focus();
        }
      };
      // Passive bubbling dismissal cannot cancel or swallow funnel taps on touch browsers.
      document.addEventListener('click', this.handleDocumentClick, { passive: true });
      document.addEventListener('keydown', this.handleEscape);
    }

    initializeHeaderCartSuppression() {
      if (detachedHeaderCart) return;
      const cart = document.querySelector('.t4s-site-nav__cart');
      if (!cart) return;
      detachedHeaderCart = { node: cart, parent: cart.parentNode, nextSibling: cart.nextSibling };
      cart.remove();
    }

    selectPack(pack) {
      if (pack) {
        this.packInputs.forEach((input) => { input.checked = input === pack; });
        const marketPrice = this.marketPrice(pack);
        if (marketPrice > 0) pack.dataset.price = String(marketPrice);
      }
      const packPrice = this.querySelector('[data-pack-price]');
      if (packPrice) packPrice.textContent = pack ? this.money(Number(pack.dataset.price)) : '';
      if (this.packCta) this.packCta.disabled = !pack;
    }
    marketPrice(pack) {
      const attributePrice = Number(pack?.dataset.price);
      if (attributePrice > 0) return attributePrice;

      // In some Shopify Markets, variant.price is blank in data attributes even
      // though the market-localized money output beside it is populated.
      const priceText = pack?.closest('.cp-psf__pack')?.querySelector('[data-market-price]')?.textContent;
      if (!priceText) return 0;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: this.currency,
        currencyDisplay: 'narrowSymbol'
      });
      const parts = formatter.formatToParts(12345.6);
      const group = parts.find((part) => part.type === 'group')?.value;
      const decimal = parts.find((part) => part.type === 'decimal')?.value;
      let numeric = priceText.replace(/[^\d.,'’\s-]/g, '').trim();
      if (group) numeric = numeric.split(group).join('');
      numeric = numeric.replace(/[\s'’]/g, '');
      if (decimal && decimal !== '.') numeric = numeric.replace(decimal, '.');
      const amount = Number.parseFloat(numeric);
      const fractionDigits = formatter.resolvedOptions().maximumFractionDigits;
      return Number.isFinite(amount) ? Math.round(amount * (10 ** fractionDigits)) : 0;
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: this.currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    cleanCartText(value) {
      return String(value || '')
        .replace(/\bdefault title\b/gi, '')
        .replace(/\s*\|\s*upc\b.*$/i, '')
        .replace(/\s*\|\s*barcode\b.*$/i, '')
        .replace(/^\s*\|\s*|\s*\|\s*$/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
    }
    escapeHtml(value) {
      return String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
    }
    async cartRequest(path, body) {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}${path}`, {
        method: body ? 'POST' : 'GET',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        body: body ? JSON.stringify(body) : undefined
      });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      return response.json();
    }
    async refreshDesktopCart(open = false) {
      if (!this.desktopCart) return;
      try {
        this.realCart = await this.cartRequest('cart.js');
        this.renderDesktopCart();
        this.renderRealCartMobile();
        if (open) {
          if (this.desktopBreakpoint.matches) this.setDesktopCartExpanded(true);
          else this.toggleMiniCart();
        }
      } catch (error) {
        console.error('Protect Spray Funnel cart refresh failed', error);
      }
    }
    async addDesktopVariant(id, quantity = 1, open = true) {
      try {
        await this.cartRequest('cart/add.js', { items: [{ id: Number(id), quantity }] });
        await this.refreshDesktopCart(open);
      } catch (error) {
        console.error('Protect Spray Funnel cart add failed', error);
      }
    }
    async toggleDesktopProduct(button) {
      const variantId = String(button.dataset.variantId || '');
      const item = this.realCart?.items?.find((line) => String(line.variant_id) === variantId);
      if (item) await this.changeDesktopLine(item.key, 0);
      else await this.addDesktopVariant(variantId, 1, true);
    }
    async changeDesktopLine(key, quantity) {
      try {
        this.realCart = await this.cartRequest('cart/change.js', { id: key, quantity });
        this.renderDesktopCart();
        this.renderRealCartMobile();
        this.setDesktopCartExpanded(true);
      } catch (error) {
        console.error('Protect Spray Funnel cart update failed', error);
      }
    }
    handleDesktopCartAction(event) {
      const action = event.target.closest('[data-real-cart-action]');
      if (!action) return;
      const item = this.realCart?.items?.find((line) => line.key === action.dataset.lineKey);
      if (!item) return;
      const quantity = action.dataset.realCartAction === 'remove' ? 0 : Math.max(0, item.quantity + (action.dataset.realCartAction === 'increase' ? 1 : -1));
      this.changeDesktopLine(item.key, quantity);
    }
    setDesktopCartExpanded(expanded) {
      if (!this.desktopCart) return;
      this.desktopCart.dataset.expanded = String(expanded);
      const toggle = this.querySelector('[data-desktop-cart-toggle]');
      const body = this.querySelector('[data-desktop-cart-body]');
      const collapsed = this.querySelector('[data-desktop-cart-collapsed]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.innerHTML = `${expanded ? 'Hide' : 'View'} items <span aria-hidden="true">${expanded ? '▾' : '▴'}</span>`;
      }
      if (body) body.hidden = !expanded;
      if (collapsed) collapsed.hidden = expanded;
      requestAnimationFrame(() => this.syncStickyClearance?.());
    }
    renderDesktopCart() {
      if (!this.realCart || !this.desktopCartItems) return;
      const { items = [], item_count: count = 0, total_price: total = 0 } = this.realCart;
      this.desktopCartItems.replaceChildren(...items.map((item) => {
        const card = document.createElement('article');
        card.className = 'cp-psf__desktop-cart-card';
        const title = this.escapeHtml(this.cleanCartText(item.product_title || item.title));
        const variant = this.escapeHtml(this.cleanCartText(item.variant_title));
        const key = this.escapeHtml(item.key);
        const image = this.escapeHtml(item.image);
        card.innerHTML = `<div class="cp-psf__desktop-cart-thumb">${image ? `<img src="${image}" alt="">` : ''}</div><div class="cp-psf__desktop-cart-copy"><strong>${title}</strong><span>${variant}</span><div class="cp-psf__desktop-cart-card-foot"><div class="cp-psf__desktop-qty"><button type="button" data-real-cart-action="decrease" data-line-key="${key}" aria-label="Decrease ${title}">−</button><span>${item.quantity}</span><button type="button" data-real-cart-action="increase" data-line-key="${key}" aria-label="Increase ${title}">+</button></div><b>${this.money(item.final_line_price)}</b></div></div><button type="button" class="cp-psf__desktop-remove" data-real-cart-action="remove" data-line-key="${key}" aria-label="Remove ${title}">×</button>`;
        return card;
      }));
      const set = (selector, value) => { const node = this.querySelector(selector); if (node) node.textContent = value; };
      set('[data-desktop-cart-count]', count);
      set('[data-desktop-cart-summary]', `${count} ${count === 1 ? 'item' : 'items'} in your kit`);
      set('[data-desktop-subtotal-label]', `Subtotal · ${count} ${count === 1 ? 'item' : 'items'}`);
      set('[data-desktop-total]', this.money(total));
      const threshold = Number(this.dataset.shippingThreshold || 0);
      const remaining = Math.max(0, threshold - total);
      set('[data-desktop-shipping]', threshold > 0 && remaining === 0 ? this.dataset.shippingUnlocked : this.dataset.shippingCopy.replace('[amount]', this.money(remaining)));
      const progress = this.querySelector('[data-desktop-progress]');
      if (progress) progress.style.width = threshold > 0 ? `${Math.min(100, total / threshold * 100)}%` : '0%';
      const stack = this.querySelector('[data-desktop-cart-stack]');
      if (stack) {
        stack.replaceChildren(...items.slice(0, 5).map((item) => {
          const thumb = document.createElement('span');
          thumb.innerHTML = `${item.image ? `<img src="${item.image}" alt="">` : ''}${item.quantity > 1 ? `<b>${item.quantity}</b>` : ''}`;
          return thumb;
        }));
      }
      this.crossSells.forEach((button) => {
        const active = items.some((item) => String(item.variant_id) === String(button.dataset.variantId));
        button.setAttribute('aria-pressed', String(active));
        const label = button.querySelector('[data-toggle-label]');
        if (label) label.textContent = active ? this.dataset.removeLabel || 'Remove' : this.dataset.addLabel || '+ Add';
      });
      this.syncDesktopCartArrows();
      requestAnimationFrame(() => this.syncStickyClearance?.());
    }
    syncDesktopCartArrows() {
      if (!this.desktopCartItems) return;
      const max = this.desktopCartItems.scrollWidth - this.desktopCartItems.clientWidth;
      this.desktopCartItems.classList.toggle('has-left-overflow', this.desktopCartItems.scrollLeft > 2);
      this.desktopCartItems.classList.toggle('has-right-overflow', this.desktopCartItems.scrollLeft < max - 2);
      const previous = this.querySelector('[data-cart-scroll="previous"]');
      const next = this.querySelector('[data-cart-scroll="next"]');
      if (previous) previous.disabled = this.desktopCartItems.scrollLeft <= 2;
      if (next) next.disabled = this.desktopCartItems.scrollLeft >= max - 2;
    }
    toggleMiniCart() {
      if (!this.miniCart) return;
      this.miniCart.hidden = false;
      this.cartSummary?.setAttribute('aria-expanded', 'true');
    }
    closeMiniCart() {
      if (!this.miniCart) return;
      this.miniCart.hidden = true;
      this.cartSummary?.setAttribute('aria-expanded', 'false');
    }
    decrementLine(id, type) {
      const line = this.realCart?.items?.find((item) => item.key === id);
      if (line) this.changeDesktopLine(line.key, Math.max(0, line.quantity - 1));
    }
    createCartLine(line) {
        const row = document.createElement('div');
        row.className = 'cp-psf__mini-cart-line';
        const thumb = document.createElement('div');
        thumb.className = 'cp-psf__mini-cart-thumb';
        if (line.image) {
          const image = document.createElement('img');
          image.src = line.image;
          image.alt = '';
          image.width = 32;
          image.height = 32;
          thumb.append(image);
        }
        const quantity = document.createElement('span');
        quantity.className = 'cp-psf__mini-cart-quantity';
        quantity.textContent = `x${line.quantity}`;
        const remove = document.createElement('button');
        remove.className = 'cp-psf__mini-cart-remove';
        remove.type = 'button';
        remove.dataset.removeLine = line.key || line.id;
        remove.dataset.lineType = 'real';
        remove.setAttribute('aria-label', `${this.dataset.removeLabel || 'Remove'} ${line.title}`);
        remove.textContent = '−';
        thumb.append(quantity);
        thumb.append(remove);
        const copy = document.createElement('div');
        copy.className = 'cp-psf__mini-cart-copy';
        const displayTitle = [line.title, line.pdpTitle, line.productTitle, line.variantTitle]
          .map((value) => this.cleanCartText(value))
          .find(Boolean);
        const title = document.createElement('span');
        title.className = 'cp-psf__mini-cart-name';
        title.textContent = displayTitle || '';
        copy.append(title);
        const price = document.createElement('strong');
        price.className = 'cp-psf__mini-cart-price';
        price.textContent = this.money(line.linePrice ?? line.price * line.quantity);
        row.append(thumb, copy, price);
        return row;
    }
    renderMiniCart(lines) {
      if (!this.miniCartLines) return;
      this.miniCartLines.replaceChildren();
      this.querySelector('[data-mini-cart-empty]').hidden = lines.length > 0;
      lines.forEach((line) => {
        this.miniCartLines.append(this.createCartLine(line));
      });
    }
    renderInlineCart(lines) {
      if (!this.inlineCartLines) return;
      this.inlineCartLines.replaceChildren();
      this.querySelector('[data-inline-cart-empty]').hidden = lines.length > 0;
      lines.forEach((line) => {
        this.inlineCartLines.append(this.createCartLine(line));
      });
    }
    renderRealCartMobile() {
      if (!this.realCart) return;
      const lines = this.realCart.items.map((item) => ({
        id: String(item.variant_id),
        key: item.key,
        title: item.product_title || item.title,
        productTitle: item.product_title,
        variantTitle: item.variant_title,
        image: item.image,
        linePrice: item.final_line_price,
        price: item.final_price,
        quantity: item.quantity
      }));
      const count = this.realCart.item_count || 0;
      const total = this.realCart.total_price || 0;
      const threshold = Number(this.dataset.shippingThreshold || 0);
      const remaining = Math.max(0, threshold - total);
      const shippingText = threshold <= 0 ? '' : remaining === 0 ? this.dataset.shippingUnlocked : this.dataset.shippingCopy.replace('[amount]', this.money(remaining));
      this.renderMiniCart(lines);
      this.renderInlineCart(lines);
      this.querySelector('[data-total]').textContent = this.money(total);
      this.querySelector('[data-item-count]').textContent = `${count} × ${count === 1 ? this.dataset.itemSingular : this.dataset.itemPlural}`;
      this.querySelector('[data-sticky-shipping]').textContent = shippingText;
      this.querySelectorAll('[data-shipping-progress]').forEach((progress) => {
        progress.style.width = threshold > 0 ? `${Math.min(100, total / threshold * 100)}%` : '0%';
      });
      if (this.checkoutButton) this.checkoutButton.disabled = count === 0;
      if (this.footerAction) this.footerAction.textContent = count > 0 ? this.footerAction.dataset.checkoutLabel : this.footerAction.dataset.chooseLabel;
    }
    async checkout() {
      if ((this.realCart?.item_count || 0) > 0) window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    }
  });
}
